import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from './../../../../shared/service/base-config.service';
import { GenericHttpService } from './../../../../shared/service/generic-http.service';
import { DadosOnInitModelView, IndiceParticipacaoMunicipioFiltro, IndiceParticipacaoMunicipioModelView } from './../model/IndiceParticipacaoMunicipio.model';
import { ExportTypes } from '../../../../shared/enum/TypeExportReportEnums';

@Injectable()
export class IndiceParticipacaoMunicipioService {
  private readonly urlBase: string;

  constructor(
    private baseConfig:BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario (): Observable<DadosOnInitModelView> {

    let retorno: Observable<DadosOnInitModelView> = null;

    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/consulta/IndiceParticipacaoMunicipios/DadosOnInitFormulario'), null);

    return retorno;
  }

  public consultarIndiceParticipacaoMunicipio(filtro : IndiceParticipacaoMunicipioFiltro ): Observable<IndiceParticipacaoMunicipioModelView> {

    let retorno: Observable<IndiceParticipacaoMunicipioModelView> = null;

    retorno = this.http.post(this.baseConfig.getBaseUrlApi().concat('/consulta/IndiceParticipacaoMunicipios/ConsultarIndiceParticipacaoMunicipio'), filtro);

    return retorno;
  }

  public  gerarRelatorioIndiceParticipacao(filtro: IndiceParticipacaoMunicipioFiltro,
    tipoRel: ExportTypes): Observable<Blob>{
    const url = this.baseConfig.getBaseUrlApi().concat('/consulta/IndiceParticipacaoMunicipios/GerarRelatorioIndiceParticipacao');
    return this.http.report(url, filtro,tipoRel);
  }
}


// WEBPACK FOOTER //
// ./src/app/consulta/indice-participacao-municipio/shared/service/indiceParticipacaoMunicipio.ts